import { ISurveyFormQuestion } from "../@types/Proms";
import { ISurveyAnswer } from "../@types/Surveys";

function normalizeFiveQuestionsAboutSupOxAnswer(
  answer: string | undefined
): string {
  const parts = (answer ?? "").split("|").filter((x) => x !== "");

  const normalized = Array.from(
    { length: 5 },
    (_, i) => parts[i] ?? "no_answer"
  ).map((p) => {
    if (p === "no_answer") return "no_answer";
    const n = Number(p);
    return Number.isNaN(n) ? "no_answer" : String(n);
  });

  return normalized.join("|");
}

export function getSurveyFormsAnswersToEdit(questions: ISurveyFormQuestion[]) {
  return questions.map((question) => {
    const surveyAnswer: ISurveyAnswer = {
      surveyQuestionId: question.questionId,
      answerValue: question.answer,
    };

    if (question.questionOptionIds?.length) {
      surveyAnswer.surveyQuestionOptionIds = question.questionOptionIds;
    }

    if (question.type === "FiveQuestionsAboutSupOx") {
      surveyAnswer.answerValue = normalizeFiveQuestionsAboutSupOxAnswer(
        question.answer
      );
    }

    return surveyAnswer;
  });
}

export const hasSurveyAnswerValueChanged = (
  original: ISurveyAnswer[],
  updated: ISurveyAnswer[]
): boolean => {
  const originalMap = new Map(
    original.map((a) => [a.surveyQuestionId, a.answerValue])
  );
  const updatedMap = new Map(
    updated.map((a) => [a.surveyQuestionId, a.answerValue])
  );

  // Check for new-updated answers
  const hasNewOrChangedAnswers = updated.some((updatedAnswer) => {
    const originalValue = originalMap.get(updatedAnswer.surveyQuestionId);
    return (
      originalValue === undefined || originalValue !== updatedAnswer.answerValue
    );
  });

  if (hasNewOrChangedAnswers) return true;

  // Check for removed answers
  const hasRemovedAnswers = original.some((originalAnswer) => {
    const stillExists = updatedMap.has(originalAnswer.surveyQuestionId);
    const hadRealAnswer =
      originalAnswer.answerValue && originalAnswer.answerValue !== "no_answer";
    return !stillExists && hadRealAnswer;
  });

  return hasRemovedAnswers;
};
